var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotosessions = function SvgPhotosessions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M23.27 3.27q.996 0 1.699.761.762.703.761 1.7v15a2.48 2.48 0 0 1-.761 1.816 2.32 2.32 0 0 1-1.7.703H3.23q-.996 0-1.757-.703A2.59 2.59 0 0 1 .77 20.73v-15q0-.996.703-1.699.76-.762 1.757-.761h3.985L9.5.75H17l2.285 2.52zm0 17.46v-15H3.23v15zM15.77 12l-3.75 4.629L9.5 13.23l-3.75 5.04h15z"
  })));
};
export default SvgPhotosessions;